// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2530": "e96a97f91d26","4894": "6837c71fb25f","5336": "5083bc5218c4","5608": "f0b527b205c5","6801": "ca98ae679f56","6863": "454c9f289029","8357": "dd422574e14d",}[chunkId] + ".css"
}